/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.bestellung.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from './app.config.service';
import {Observable} from 'rxjs';
import {Artikel} from '../models/artikel';
import {AppEventService} from './app.event.service';
import {AppLieferkundeService} from './app.lieferkunde.service';
import {Lieferkunde} from '../models/lieferkunde';
import {AppPageloaderService} from './app.pageloader.service';
import {Bestellung} from '../models/bestellung';
import {BestellungEntry} from '../models/bestellung-entry';
import {Subbestellung} from '../models/subbestellung';
import {BestellungPreisUndMwstSatz} from '../models/bestellung-preis-und-mwst-satz';
import {map} from 'rxjs/operators';
import {PaginatedResult} from '../models/paginated-result';
import {BestellungListInfo} from '../models/bestellung-list-info';
import setPrototypeOf = Reflect.setPrototypeOf;

/**
 * Zweck: Beschreibt class AppBestellungService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppBestellungService {
  lieferkunde: Lieferkunde;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient, private cfg: AppConfigService, private esvc: AppEventService,
              private lksvc: AppLieferkundeService, private loader: AppPageloaderService) {
    this.lksvc.current_lieferkunde$.subscribe(lk => {
      this.lieferkunde = lk;
    });
  }

/**
 * Beschreibt Methode getInfos und ihren Rückgabevertrag.
 */
  getInfos(): Observable<BestellungListInfo> {
    return this.http.get<BestellungListInfo>(
      '/bestellung'
    );
  }

/**
 * Beschreibt Methode getList und ihren Rückgabevertrag.
 */
  getList(page, limit, search, filterOrderTypes) {
    return this.http.post<PaginatedResult<Bestellung>>(
      '/bestellung', {
        page: page,
        limit: limit,
        search: search,
        filterOrderTypes: filterOrderTypes
      }
    ).pipe(map(bs => {
      bs.data.forEach(b => {
        this.protoBestellung(b);
      });
      return bs;
    }));
  }

/**
 * Beschreibt Methode getBestellungById und ihren Rückgabevertrag.
 */
  getBestellungById(id: number): Observable<Bestellung> {
    return this.http.get<Bestellung>(
      '/bestellung/' + id
    ).pipe(map(b => {
      this.protoBestellung(b);
      return b;
    }));
  }

/**
 * Beschreibt Methode protoBestellung und ihren Rückgabevertrag.
 */
  public protoBestellung(best: Bestellung) {
    if (best) {
      setPrototypeOf(best, Bestellung.prototype);
      best.view_collapsed = true;

      if (best.subbestellungen) {
        best.subbestellungen.forEach(e => {
          setPrototypeOf(e, Subbestellung.prototype);

          if (e.positionen) {
            e.positionen.forEach(p => {
              setPrototypeOf(p, BestellungEntry.prototype);

              if (p.artikel) {
                setPrototypeOf(p.artikel, Artikel.prototype);
              }
            });
          }

          if (e.summen) {
            e.summen.forEach(s => {
              setPrototypeOf(s, BestellungPreisUndMwstSatz.prototype);
            });
          }


        });
      }
    }
  }
}
